import { mutator } from 'satcheljs';
import { addInsertLinkViewState, removeInsertLinkViewState } from '../actions/internalActions';
import InsertLinkViewState from '../store/schema/InsertLinkViewState';
import getStore from '../store/store';

mutator(addInsertLinkViewState, actionMessage => {
    const store = getStore();
    const InsertLinkViewState: InsertLinkViewState = {
        linkId: actionMessage.linkId,
        isRetrievingSharingLink: true,
        file: actionMessage.file,
    };

    store.insertLinks.set(actionMessage.linkId, InsertLinkViewState);
});

mutator(removeInsertLinkViewState, actionMessage => {
    const store = getStore();
    store.insertLinks.delete(actionMessage.linkId);
});
